<template>
  <a-cascader
    :fieldNames="{ label: 'label', value: 'value', children: 'children' }"
    :options="areaOptions"
    @change="areaChange"
    @blur="onBlur"
    v-model="selectedArea"
    :show-search="{ filter }"
    :changeOnSelect="changeOnSelect"
    :placeholder="placeholder" :style="areaStyle"></a-cascader>
</template>

<script>
import Vue from 'vue'
import citiesHelper from '@/utils/helper/citiesHelper'
import { SET_CITY_FLAG } from '@/store/mutation-types'
import dbManager from '@/utils/indexeDb'

export default {
  name: 'AreaSelected',
  props: {
    placeholder: {
      type: String,
      default: '请选择区域'
    },
    changeOnSelect: {
      type: Boolean,
      default: false
    },
    //all 所有地址 ,out 国外,in国内
    areaType: {
      type: String,
      default: 'in'
    },
    areaStyle: {
      type: Object,
      default: function() {
        return {}
      }
    },
    onlyCity: {
      type: Boolean,
      default: false
    },
    templateOnlyCity: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function() {
        return []
      }
    },
    isNewCity: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      areaOptions: [],
      // onlyCityOption: [],
      selectedArea: [],
      selectedOptions: []
    }
  },
  watch: {
    'areaOptions': function(newVal, oldVal) {
      // this.onlyCityOption = this.getCityOptions(newVal)
    },
    'value': function(newVal, oldVal) {
      this.selectedArea = newVal ? newVal : []
    },
    'areaType': function(newVal, oldVal) {
      this.updateCityOptions(newVal)
    }

  },

  mounted() {
    this.selectedArea = this.value ? this.value : []
    this.updateCityOptions(this.areaType)
  },
  methods: {
    onBlur() {
      this.$emit('blur', { selectedOptions: this.selectedOptions, value: this.selectedArea })
    },
    areaChange(value, selectedOptions) {
      this.selectedOptions = selectedOptions
      this.$emit('input', value)
      this.$emit('change', { value: value, selectedOptions: selectedOptions })
    },
    updateCityOptions(areaType) {
      if (!this.isNewCity) {
        citiesHelper.getAllCities()
          .then(list => {
            if (areaType === 'all') {
              this.areaOptions = list
            } else if (areaType === 'out') {
              this.areaOptions = list[1].children
            } else if (areaType === 'in') {
              this.areaOptions = list[0].children
            }
            this.getLogUtils().logWithTag('updateCityOptions', this.areaOptions)
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.$store.dispatch('GetGlobalCity').then(cityList => {
          this.getLogUtils().logWithTag('GetGlobalCity', cityList)
          if (cityList && cityList.length > 0) {
            if (this.templateOnlyCity) {
              var onlyList = cityList
              onlyList[0].children = this.filterList(onlyList[0].children, 2, 1)
            }
            if (areaType === 'all') {
              this.areaOptions = cityList
            } else if (areaType === 'out') {
              this.areaOptions = cityList[1].children
            } else if (areaType === 'in') {
              this.areaOptions = this.templateOnlyCity ? onlyList[0].children : cityList[0].children
            }
          } else {
            Vue.ls.remove(SET_CITY_FLAG)
            dbManager.GlobalCity.remove(1).catch(err => {
              console.error('dbManager', err)
            })
            this.$message.warning('国内外城市数据加载中，请稍等一会,暂不要刷新页面', 10)
            this.$store.dispatch('SaveGlobalCity').then((data) => {
              if (data && data.cityList && data.cityList.length > 0) {
                this.$message.success('国内外城市数据完成')
                // setTimeout(()=>{location.reload()},500)
                if (this.templateOnlyCity) {
                  var onlyList = data.cityList
                  onlyList[0].children = this.filterList(onlyList[0].children, 2, 1)
                }
                if (areaType === 'all') {
                  this.areaOptions = data.cityList
                } else if (areaType === 'out') {
                  this.areaOptions = data.cityList[1].children
                } else if (areaType === 'in') {
                  this.areaOptions = this.templateOnlyCity ? onlyList[0].children : data.cityList[0].children
                }
              }
            })
          }

        }).catch(error => {
          this.getLogUtils().logWithTag('error', error)
        })
        this.getLogUtils().logWithTag('updateCityOptions', this.areaOptions)
      }
    },
    filterList(list, maxLevel, level = 1) {
      if (list && list.length > 0) {
        list.forEach(item => {
          if (item.children && level + 1 > maxLevel) {
            item.children = undefined
          } else if (item.children && item.children.length > 0 && level + 1 <= maxLevel) {
            this.filterList(item.children, maxLevel, level + 1)
          }
        })
      }
      return list
    },
    filter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    getCityOptions(areaOptions) {
      if (areaOptions && areaOptions.length > 0) {
        let newOptions = [...areaOptions]
        newOptions.forEach(item => {
          if (item.children && item.children.length > 0) {
            if (this.areaType === 'all') {
              item.children.forEach(childrenItem => {
                childrenItem.children = this.mapChildrenOptions(childrenItem.children)
              })
            } else {
              item.children = this.mapChildrenOptions(item.children)
            }
          }
        })
        return newOptions
      }
      return []
    },
    mapChildrenOptions(children) {
      if (children && children.length > 0) {
        return children.map(childItem => {
          return {
            label: childItem.label,
            value: childItem.value
          }
        })
      }
      return undefined
    }
  }
}
</script>
<style scoped>
</style>